<script>
  import { onMount, onDestroy, afterUpdate } from "svelte";
  import Slider from "../Common/Slider.svelte";
  import ColorPicker from "../Common/ColorPicker.svelte";
  import FontPicker from "../Common/FontPicker.svelte";
  import { toolboxRender, toolboxMenuRender, toolboxTextMenuRender } from "./component-config";
  import BlockGlobal from "./ToolBox/BlockGlobal.svelte";
  import { ignore } from "../Common/tools";
  import {External, M} from "../external";

  export let onChange = ignore,
    selectedComponent = "",
    options,
    meta;
  export let selectedData, rawData;
  let jDraggable,
    selectedTab = "blocks";

  const menu = options.textEditor ? toolboxTextMenuRender() : toolboxMenuRender(meta, options.features || {});
  const toolbox = toolboxRender();

  export function switchTabStying() {
    selectedTab = "style";
  }

  function change(prop, data) {
    onChange({ [prop]: data });
  }

  function changeTab(tab) {
    selectedTab = tab;
  }

  function initializeDraggable() {
    jDraggable = External.$(".draggable");
    jDraggable.draggable({
      connectToSortable: "#sortable",
      containment: "window",
      helper: function () {
        let clone = External.$(this).clone();
        clone.css({
          width: 150,
          height: 120
        });
        return clone;
      },
      revert: "invalid",
      cursorAt: { left: 50, top: 40 }
    });
  }

  afterUpdate(function () {
    if (selectedTab === "blocks") {
      initializeDraggable();
    }
  });

  onMount(function () {
    initializeDraggable();
  });

  onDestroy(function () {
    jDraggable.draggable("destroy");
  });

  if (!selectedData || !selectedData.style) {
    selectedData = { style: {} };
  }
  selectedData.style.backgroundColor = selectedData.style.backgroundColor || "#ffffff";
  $: {
    if (selectedComponent === "global") {
      changeTab("blocks");
    }
  }
</script>

<div class="flex-none big-filter-nav email-builder-side-content-wrapper members-nav flex flex-col">
  {#if selectedTab === "style"}
    <a on:click|preventDefault={() => changeTab("blocks")} class="add-block-button rounded-effect"><span class="material-icons"> add_circle_outline </span></a>
  {/if}
  <ul class="upper-navigation upper-navigation-full mt-15">
    <li>
      <a on:click|preventDefault={() => changeTab("blocks")} class:active={selectedTab === "blocks"}>
        <span class="material-icons-outlined"> view_day </span>{M.BLOCKS}
      </a>
    </li>
    <li>
      <a on:click|preventDefault={() => changeTab("style")} class:active={selectedTab === "style"}>
        <span class="material-icons-outlined"> brush </span>{M.STYLING}
      </a>
    </li>
  </ul>
  <div class="col20 f-left email-builder-side-content">
    {#if selectedTab === "blocks"}
      {#each menu as item (item)}
        <div class="draggable" id={item}>
          <img alt="" src={External.resources + "/images/marketing/blocks/" + item + ".png?v=" + External.resourcesVersion} />
        </div>
      {/each}
    {/if}
    {#if selectedTab === "style"}
      {#if selectedData.type && toolbox[selectedData.type]}
        <svelte:component this={toolbox[selectedData.type]} bind:data={rawData.content[selectedComponent]} onChange={change} />
      {:else if selectedComponent !== "global"}
        <BlockGlobal bind:data={rawData.content[selectedComponent]} />
      {/if}
      {#if selectedComponent === "global"}
        <div class="col20 f-left t-center mb-25 mt-15">
          <h4 class="t-left email-styling-separation">{M.GLOBAL}</h4>
        </div>

        <div class="col20 f-left color-pick-wrap-widgets">
          <ColorPicker
            bind:color={selectedData.style.backgroundColor}
            label={M.BACKGROUND_COLOR}
            alpha="no"
            onChange={(color) => change("backgroundColor", color)} />
        </div>

        <div class="popup-input-wrapper input-slider-wrapper mt-5">
          <FontPicker useOnlyEmailSafeFonts={true} bind:selectedFont={rawData.style.fontFamily} />
        </div>

        <Slider
          min={300}
          max={1280}
          value={selectedData.style.width || 700}
          step={10}
          sameLine={true}
          showValue={true}
          suffix="px"
          clz="mt-5"
          onChange={(val) => change("width", val + "px")}
          label={M.WIDTH} />

        <div class="popup-input-wrapper input-slider-wrapper mt-5">
          <h5 class="inline col20 f-left">{M.ALIGNMENT}</h5>
          <select bind:value={rawData.style.align} on:change={(event) => change("align", event.target.value)}>
            <option value="">{M.ALIGN_CENTER}</option>
            <option value="left">{M.ALIGN_LEFT}</option>
            <option value="right">{M.ALIGN_RIGHT}</option>
          </select>
        </div>
      {/if}
    {/if}
  </div>
</div>
